module.exports = __webpack_public_path__ + "img/logo.506e4b0d.png";